import { containerEvents } from "../../ContainerEvents";
import { selection } from "./Selection";
import { graphic } from "../../Graphic";

export class SelectionEditionMode {

    constructor() {
        containerEvents.bindEvents(selection);
        graphic.container.pointer = 'default';
        graphic.container.buttonMode = false;
    }

    destroy() {
        graphic.container.pointer = 'inherit';
        graphic.container.buttonMode = true;
        containerEvents.unbindEvents(selection);
    }
}